<template>
    <div class="ring" ref="" v-show="showNextMsg">
        
    </div>
</template>

<script>
export default {
    name:"ring",
    props:{
        userName:{
             type: String,
             default: "客户张阿娜" 
        }
    },
    data () {
        return {
             uid:1,
             action:"",
             callback: null,
             showNextMsg:false,
        }
    },
    watch:{
        showNextMsg(val){
            if (val) {
                this.uid++;
            }
        }
    },
    methods:{
        getSafeClose() {
            const currentId = this.uid;
            return () => {
            this.$nextTick(() => {
                if (currentId === this.uid) this.doClose();
            });
            };
        },
        doClose(item){
            if (!this.showNextMsg) return;
            this.showNextMsg = false;
            setTimeout(() => {
                 if (this.action) this.callback(this.action, this, item);
            });
        },
        show(){
          this.showNextMsg = true
        },
        clsoe(tage, item){
             this.action = tage
             if (typeof this.beforeClose === 'function') {
                this.close = this.getSafeClose();
                this.beforeClose(this.action, this, this.close);
            } else {
                this.doClose(item);
            }
        },
        //挂断
        hangUp(){
            this.clsoe("hangUp")
        },
        //接听
        connect(){
            this.clsoe("connect")
        },
        //转接
        transfer(){
            // this.clsoe("transfer")
            this.callback("transfer", this, {})
        }
    }
}
</script>

<style lang="less" scoped>

</style>